import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function certification(id: string) {
  await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/certifications/${id}`
  );
}

export async function certifications() {
  await unauthenticatedHttp().get(`${window.env.API_UNAUTH}/certifications`);
}

export async function fetchUnauthCertification(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/certifications/${id}`
  );
  return data;
}
